module.exports = __webpack_public_path__ + "7dfe2ee6dbb58a1ef99f7245a322c2c5.MP3";